import React, { FC } from 'react';

interface OnboardingProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const OnboardingProgressBar: FC<OnboardingProgressBarProps> = ({
  currentStep,
  totalSteps,
}) => {
  return (
    <div className='onboarding-progress-bar'>
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          className={`progress-segment${i < currentStep ? ' active' : ''}`}
        />
      ))}
    </div>
  );
};

export default OnboardingProgressBar;
